import { Component } from 'react'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import { autobind } from 'core-decorators'
import cx from 'classnames'
import isEqual from 'lodash/isEqual'
import template from 'lodash/template'

import ensureMapLoaded from 'common/utils/ensureMapLoaded'
import classNames from './styles.module.scss'
import marker from '@img/markerList.svg'
import markerListSelected from '@img/markerListSelected.svg'
import { withRouter } from 'next/router'


let pool = []

const propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({
    place_id: PropTypes.string,
    name: PropTypes.string,
    rating: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    lat: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    lng: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  })),
  configMap: PropTypes.object,
  className: PropTypes.string,
  infoWindowContent: PropTypes.string,
  cardCount: PropTypes.number,
  schoolList: PropTypes.array,
  openAllMarkers: PropTypes.bool,
  boundsPadding: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
  ]),
  preventHover: PropTypes.bool,
  preventRedirect: PropTypes.bool,
  mapId: PropTypes.number,
  router: PropTypes.object.isRequired,
}

const defaultProps = {
  configMap: {},
  className: undefined,
  locations: [],
  infoWindowContent: undefined,
  cardCount: undefined,
  schoolList: [],
  openAllMarkers: false,
  boundsPadding: undefined,
  preventHover: false,
  preventRedirect: false,
  mapId: 1,
}
class MapMultipleMarkersContainer extends Component {
  markers = []

  componentDidMount() {
    ensureMapLoaded().then(() => {
      this.renderMap(this.props)
    })
  }

  shouldComponentUpdate(nextProps) {
    if(['locations', 'cardCount', 'mapId', 'preventRedirect', 'schoolList'].some(prop => !isEqual(this.props[prop], nextProps[prop]))) {
      if(window?.mapLoaded && google) {
        this.renderMap(nextProps)
      }
    }
    return false
  }

  @autobind
  removeMarkers() {
    this.markers.forEach((_, index) => {
      this.markers[index].setMap(null)
    })
  }

  @autobind
  renderMap(props) {
    while(pool.length) {
      let item = pool.shift()
      item.el.removeEventListener(item.event, item.listener)
    }
    this.removeMarkers()
    const markerIcon = props.markerIcon || marker
    const selectedMarkerIcon = props.markerIconSelected || props.markerIcon || markerListSelected
    const mapOptions = {
      gestureHandling: 'cooperative',
      panControl: false,
      disableDefaultUI: true,
      streetViewControl: false,
      maxZoom: 16,
      minZoom: 0,
      keyboardShortcuts: true,
      mapId: process.env.GOOGLE_MAP_ID,
      ...props.configMap,
    }
    if(!this.map) {
      // eslint-disable-next-line react/no-find-dom-node
      this.map = new google.maps.Map(findDOMNode(this).querySelector('.mapMultiple'), mapOptions)
    }
    if(!this.infowindow && !this.props.openAllMarkers) {
      this.infowindow = new google.maps.InfoWindow()
    }
    this.bounds = new google.maps.LatLngBounds()
    props.locations.forEach((location) => {
      if(this.props.openAllMarkers) {
        this.infowindow = new google.maps.InfoWindow()
      }
      const pinImg = document.createElement('img')
      pinImg.src = markerIcon

      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: new google.maps.LatLng(location.lat, location.lng),
        map: this.map,
        content: pinImg,
      })
      this.markers.push(marker)
      this.bounds.extend(marker.position)

      const setContent = () => {
        const hasRedirect = !props.preventRedirect && location.url
        this.infowindow.setContent(`
          <div class="mapInfoWrapper ${hasRedirect ? 'withLink' : ''}">
            ${template(location.tooltipContent || props.infoWindowContent)(location)}
          </div>
        `)
        this.infowindow.open(this.map, marker)
        pinImg.src = selectedMarkerIcon
        if(hasRedirect) {
          setTimeout(() => {
            // eslint-disable-next-line react/no-find-dom-node
            const el = findDOMNode(this).querySelector('.mapInfoWrapper')
            el && el.addEventListener('click', () => {
              const url = location.url.replace(/\/de\/|\/fr\//g, '/')
              this.props.router.push(url)
            })
          })
        }
      }

      if(this.props.openAllMarkers) {
        setContent()
      }
      if(!this.props.preventHover) {
        marker.content.addEventListener('mouseover', setContent)
        marker.addListener('click', setContent)
      }

      google.maps.event.addListener(this.infowindow, 'closeclick', function() {
        pinImg.src = markerIcon
      })

      google.maps.event.addListener(this.infowindow, 'content_changed', function() {
        pinImg.src = markerIcon
      })

      setTimeout(() => {
        const el = document.querySelector(`[data-map="${location.id}"]`)
        if(!el) {
          return
        }

        const mouseoverListener = () => {
          setContent()
        }
        const mouseoutListener = () => {
          google.maps.event.trigger(marker, 'mouseout')
          this.infowindow.close()
          pinImg.src = markerIcon
        }
        el.addEventListener('mouseover', mouseoverListener)
        el.addEventListener('mouseout', mouseoutListener)
        pool.push({ el, listener: mouseoverListener, event: 'mouseover' })
        pool.push({ el, listener: mouseoutListener, event: 'mouseout' })
      }, 0)
    })

    this.map.fitBounds(this.bounds, this.props.boundsPadding)
  }

  render() {
    return (
      <div className={cx(classNames.MapWrapper, this.props.openAllMarkers && classNames.openAllMarkers, this.props.className)}>
        <div className="mapMultiple" data-tap-disabled="true" />
      </div>
    )
  }
}

MapMultipleMarkersContainer.propTypes = propTypes
MapMultipleMarkersContainer.defaultProps = defaultProps

export default withRouter(MapMultipleMarkersContainer)
